import { render } from "./SurveyInputPhoneNumber.vue?vue&type=template&id=b5f9558c&ts=true"
import script from "./SurveyInputPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./SurveyInputPhoneNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__